import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
//const baseURL = 'https://conexionsap.rciempaquesplegadizos.com/'
const baseURL = 'https://testing.rciempaquesplegadizos.com/rci'
//const baseURL = 'http://localhost/rci'
//const baseURL = 'http://192.168.10.16/rci'
axios.defaults.baseURL = baseURL
//crossorigin:true
//axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8'
//axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded'
/*
const mainAxios = axios.create({
    baseURL: 'http://192.168.10.16/rci'
});

const microsoftAxios = axios.create({
    baseURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/'
});

export {
  mainAxios,
  microsoftAxios
};

*/


Vue.use(VueAxios, axios)


